import React, { useLayoutEffect, useState } from 'react'
import classNames from 'classnames'

import Logo from './loading.gif'
import LogoColor from './loading-color.gif'
import styles from './Loader.module.scss'

export enum LoaderSizes {
  ExtraSmall = 'Xs',
  Small = 'Sm',
  Medium = 'Md',
  Large = 'Lg',
}
interface ILoader {
  overlay?: boolean
  color?: boolean
  sizes?: LoaderSizes
  altImg?: string
  className?: string
  classes?: { loader?: string; logo?: string }
  children?: React.ReactNode
}
const Loader: React.FC<ILoader> = ({
  sizes = LoaderSizes.Medium,
  overlay = false,
  color = false,
  altImg = 'commons.loader.altImg',
  className = '',
  classes,
  children,
}) => {
  const [colorState, setColorState] = useState(Logo)
  useLayoutEffect(() => {
    setColorState(color ? LogoColor : Logo)
  }, [color, colorState])

  return (
    <div
      className={classNames(
        overlay && styles.overlay,
        `${styles[`${sizes}`]} ${className}`
      )}
    >
      <span className={classNames(styles.loader, classes?.loader)}>
        <img
          className={classNames(styles.logo, classes?.logo)}
          src={colorState}
          alt={altImg}
        />
        {children}
      </span>
    </div>
  )
}

export default Loader
